import { render, staticRenderFns } from "./TourPartyExtras.vue?vue&type=template&id=54f39f4b&"
import script from "./TourPartyExtras.vue?vue&type=script&lang=js&"
export * from "./TourPartyExtras.vue?vue&type=script&lang=js&"
import style0 from "./TourPartyExtras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourPartyExtras.vue"
export default component.exports